'use client';

import { AccordionItem, Flex, freddyTheme, Radio, Typography } from '@coolblue-development/freddy';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useTranslation } from '@i18n/useTranslation';

import { SLUGS } from './slugs';
import { identifier, options } from './Sorting';
import SortingWrapper from './SortingWrapper';

export default function MobileSorting() {
  const { t } = useTranslation('webshop.filterPage.sortSelect');
  const { language } = useRequestContext();

  return (
    <SortingWrapper id={identifier} name={identifier} isMobile>
      <AccordionItem
        title={
          <Flex gap={200} direction='column'>
            <Typography
              variant='h5'
              component='span'
              mb={0}
              truncateLines={1}
              overflowWrap='normal'
            >
              {t('mobileLabel')}
            </Typography>
          </Flex>
        }
      >
        <Flex
          component='label'
          direction='column'
          gap={200}
          sx={{
            gap: freddyTheme.spacing[200],
            cursor: 'pointer',
            '& input[type="radio"]': {
              marginTop: freddyTheme.spacing[50]
            }
          }}
        >
          {options.map(option => (
            <Radio key={option} label={t(option)} value={SLUGS[option][language]} />
          ))}
        </Flex>
      </AccordionItem>
    </SortingWrapper>
  );
}
